import React from "react";
import { Plane } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { SectionLayout, SectionIntro, Panel } from "@/components/SectionLayout";
import { FlightItinerary } from "@/components/guide/FlightItinerary";

export const TravelDetails = ({ data }) => {
  const { L, t } = useLang();
  const { content } = useContent();
  const dep = content?.departures;

  return (
    <SectionLayout id="travel" icon={Plane}>
      <SectionIntro>{L(data?.intro)}</SectionIntro>

      <h2 className="mb-4 font-display text-xl font-bold text-[#0A192F]">{t("flights.title")}</h2>
      <FlightItinerary />

      {dep && (
        <>
          <h2 className="mb-3 mt-8 font-display text-xl font-bold text-[#0A192F]">{t("travel.departures")}</h2>
          {dep.note && <p className="mb-4 text-sm leading-relaxed text-slate-600">{L(dep.note)}</p>}
          <div className="space-y-3">
            {[dep.ottawa, dep.ottawaIndependent, dep.toronto].filter(Boolean).map((g, gi) => (
              <Panel key={gi} data-testid={`departure-group-${gi}`}>
                <h3 className="mb-1 font-display text-lg font-bold text-[#0A192F]">{L(g.title)}</h3>
                {g.subtitle && (
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.12em] text-[#D4AF37]">{L(g.subtitle)}</p>
                )}
                <ul className="space-y-2">
                  {(g.steps || []).map((s, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-sm text-[#0A1128]/75">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#D4AF37]" />
                      {L(s)}
                    </li>
                  ))}
                </ul>
              </Panel>
            ))}
          </div>
        </>
      )}

      {data?.arrivalInstructions && (
        <Panel className="mt-6 bg-gradient-to-br from-[#F1F5F9] to-white">
          <h3 className="mb-2 font-display text-lg font-bold text-[#0A192F]">{t("flights.airportMeet")}</h3>
          <p className="text-sm font-light leading-relaxed text-[#0A1128]/75">{L(data.arrivalInstructions)}</p>
        </Panel>
      )}
    </SectionLayout>
  );
};
